import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2';

import { environment } from '../../environments/environment';
import { ServicesService } from '../services/services.service';

// import { NgxSpinnerService } from 'ngx-spinner';
// import { $ } from 'protractor';
@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css'],
})
export class ClientsComponent implements OnInit {
  public loading = false;
  isLoader: boolean = false;
  public show:boolean = false;
  apiBaseUrl = environment.apiBaseUrl;
  spinLoader = {
    filter : false,
  };
  isListData=true;
  isListDataEmpty =false;
  isOnePage=false;
  clientForm:FormGroup;
  errorClientName: boolean = false;
  errorAddress: boolean = false;
  errorDetail: boolean = false;
  errorVatNo: boolean = false;
  errorCountry: boolean = false;
  countryDropdownSettings: any = {};
  countryList = [];
  selectedcountry;
  countryEditDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'country_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    closeDropDownOnSelection:true,
    itemsShowLimit: 1,
    allowSearchFilter: true,
    noDataAvailablePlaceholderText:'No Country Found',
  };
  role_id;

  constructor(private _services: ServicesService, private router: Router, public translate: TranslateService) {}

  ngOnInit() { 
    this.clientDropDownFun();

    this._services.checkToken('status');
    this.getPageRequest();
      this.clientForm = new FormGroup({
        'client_name':new FormControl(),
        'email_id': new FormControl(),
        'mobile': new FormControl(),
        'address': new FormControl(),
        'detail': new FormControl(),
        'vat_no': new FormControl(),
        'client_id': new FormControl(),
        'country': new FormControl()
      });

      this._services.getRequestNoToken('get-countries').subscribe((data: any) => {
          this.countryList = data;
      });

      const userData = JSON.parse(localStorage.getItem('userData'));

      this.role_id = userData.role_id;
        
  }

  resetSearchField(){
    this.spinLoader['filter'] = true;
    this.searchFields=[''];
    this.getPageRequest();
  }

  getSearchRequest(){
    this.spinLoader['filter'] = true;
    this.getPageRequest();
  }

  clientDropDownFun(){
    
    this.countryDropdownSettings = {
          singleSelection: false,
          idField: 'id',
          textField: 'country_name',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          closeDropDownOnSelection:true,
          itemsShowLimit: 1,
          allowSearchFilter: true,
          noDataAvailablePlaceholderText:'No Country Found',
      };
  }

  

  addClient(){
    this.router.navigateByUrl('/client-details');
  }

  status:any;
  deleteClient(id,name){
    $('#deleteSpinner_'+id).removeClass('hidden');
    swal({
      title: 'Are you sure?',
      text: 'You want to Delete Client '+name,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#163862',
      cancelButtonColor: 'rgb(245, 54, 92)',
      confirmButtonText: 'Yes'
    }).then((result) => {
        if(result.value==true){
          this.route = 'delete-client';
          let token = this._services.getToken();
          var data = {
            'client_id':id,
            page  : this.currentPage,
            search: {
              'client_name' : this.searchFields['client_name']
            },
            sort  : this.sortingData
          };
          this._services.postRequest(data,this.route,token).subscribe((data: any) => {
            if(this._services.checkToken(data.status)){
              swal({
                title: 'Deleted.',
                text: data.message,
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: 'rgb(17, 205, 239)',
                cancelButtonColor: 'rgb(245, 54, 92)',
                confirmButtonText: 'Yes'
              }).then(() => {
                $('#deleteSpinner_'+id).addClass('hidden');
                this.listData = data.result;
                this.paginate = data.paginate;
                this.getPages(this.paginate.last_page);
              });
            }
          });
        }else{
          $('#deleteSpinner_'+id).addClass('hidden');
        }
    });
    
  }

  fields = [
      {
        'field': 'client_name',
        'title': 'Name',
        'width': '15%',
        'code':true,
        'sort':true
      },
      {
        'field': 'total_orders',
        'title': 'Orders',
        'width': '15%',
        'code':false,
        'sort':true
      },
      {
        'field': 'total_loadsheets_delivered',
        'title': 'Loads Scheduled',
        'width': '15%',
        'code':false,
        'sort':true
      },
      {
        'field': 'total_deliveries_delivered',
        'title': 'Deliveries Completed',
        'width': '20%',
        'code':false,
        'sort':true
      },
    {
      'field': 'country_name',
      'title': 'Country Name',
      'width': '20%',
      'code':false,
      'sort':true
    }
  ]
  
  sortType : string = '';
  sortField: string = '';
  oldField: string;
  sortingData= {
    'field' : '',
    'type'  : ''
  };

  sortBy(field, event){
    this.spinLoader['filter'] = true;
    this.oldField = (this.oldField != field) ? this.oldField : field;
    if(typeof this.oldField !== 'undefined'){
      ////console.log(document.getElementById('fa-'+this.oldField));
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-up');
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-down');
      document.getElementById('fa-'+this.oldField).classList.add('fa-sort');
    }

    event.target.classList.add('fa');

    this.sortField = field;
    this.sortType = (this.sortType == 'desc') ? 'asc' : 'desc';

    switch(this.sortType){
      case 'desc' : {
        event.target.classList.remove('fa-sort-up');
        event.target.classList.add('fa-sort-down');
        this.oldField = field;
      }break;
      case 'asc'  : {
        event.target.classList.remove('fa-sort-down');
        event.target.classList.add('fa-sort-up');
        this.oldField = field;
      }break;
      default     : {
        event.target.classList.add('fa-sort');
      }
    }

    this.sortingData = {
      'field' : this.sortField,
      'type'  : this.sortType
		};
		
    this.getPageRequest();
  }

  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate= {
    'last_page' : 1
  };
  route:string;
  searchFields= [];
  pages: any;
  listData = [];
  editData: Object = {};

  previousPage(){
    this.spinLoader['filter'] = true;
    if(this.currentPage == 1){
      return;
    }
    this.currentPage = this.currentPage -1;
    this.getPageRequest();
  }

  nextPage() {
    this.spinLoader['filter'] = true;
    if (this.paginate.last_page-1 < this.currentPage) {
      return;
    }

    this.currentPage ++;
    this.getPageRequest();
  }

  changePage(){
    this.spinLoader['filter'] = true;
    this.currentPage = this.currentPage;
    this.getPageRequest();
  }

  getPages(n){
    if(n>1){
      this.isOnePage=true;
    }else{
      this.isOnePage=false;
    }
    var data = [];
    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }

  /*------------------------------Pagination Integration Starts Here------------------------*/

  getPageRequest(){
    this.route  = 'get-client-list';
    let countriesIdArray = [];
    countriesIdArray = this.searchFields['country'] && this.searchFields['country'].map(v => v.id);
    

    switch(this.route){

      case 'get-client-list':{
        var data = {
          page  : this.currentPage,
          search: {
            'client_name' : this.searchFields['client_name'],
            'country'     : countriesIdArray
          },
          sort  : this.sortingData
        };
      }
        break;
    }
			const token = localStorage.getItem('userToken');
			this._services.requestCreator(data, this.route, token).subscribe((result: any) => {
      if(this._services.checkToken(result.status)){

        this.spinLoader['filter'] = false;
        this.isListData=false;
        this.listData = [];
        this.listData = result.result;
        // //console.log(this.listData);
        this.paginate = result.paginate;
        this.currentPage = result.paginate.current_page;
        if(this.listData.length === 0){
          this.isListDataEmpty = true;
        }
        else{
          this.isListDataEmpty=false;
        }
        if(result.paginate.current_page > result.paginate.last_page){
          this.currentPage = result.paginate.last_page;
        }
        this.getPages(this.paginate.last_page);
      }else{return false;}
    });
    return true;
  }
  
  isViewClientInfo:boolean=false;
  tempClientInfo:any;

  viewClientInfo(clientInfo){
    this.tempClientInfo = clientInfo;
    ////console.log(clientInfo);
    this.isViewClientInfo = true;
    let temp = this.tempClientInfo;

    /** fetching country index */
    var data = this.countryList;
    var selectedcountry = [];
    var index = -1;
    var val = temp.country;
    
    for(let i = 0; i < data.length; i++){
      if(data[i].id === val){
        index = i;
      }
    }
    
    if(index < 0 ){
      selectedcountry = [];
    }
    else{
      selectedcountry[0]   = data[index];
    }
  




      this.clientForm = new FormGroup({
          'client_name':new FormControl(temp.client_name,Validators.required),
          'email_id': new FormControl(temp.email_id),
          'mobile': new FormControl(temp.mobile),
          'address': new FormControl(temp.address),
          'detail': new FormControl(temp.detail),
          'vat_no': new FormControl(temp.vat_no),
          'client_id': new FormControl(temp.client_id),
          'country': new FormControl(selectedcountry)
        });
     // this.clientForm.disable();
     
  }

  viewClientsList(){
    // ////console.log
    this.isViewClientInfo = false;
    this.tempClientInfo='';
  }
  updateClient() {
    //console.log(this.clientForm.value);

    if(this.clientForm.value.client_name=='' || this.clientForm.value.client_name==null) {
      this.errorClientName=true;
      return false;
    }else{
      this.errorClientName=false;
    }
    if(this.clientForm.value.address==''|| this.clientForm.value.address==null ){
      this.errorAddress=true;
      return false;
    }else{
      this.errorAddress=false;
    }
    if(this.clientForm.value.vat_no=='' || this.clientForm.value.vat_no==null){
      this.errorVatNo=true;
      return false;
    }else{
      this.errorVatNo=false;
    }
    if(this.clientForm.value.detail=='' || this.clientForm.value.detail==null){
      this.errorDetail=true;
      return false;
    }else{
      this.errorDetail=false;
    }
    if(this.clientForm.value.country=='' || this.clientForm.value.country==null|| this.clientForm.value.country==[]){
      this.errorCountry=true;
      return false;
    }else{
      this.errorCountry=false;
    }
    


    this._services.requestCreator(this.clientForm.value,'update-client', this._services.getToken()).subscribe((data:any) => {
      if (this._services.checkToken(data.status)) {
        if (data.status == '200') {
          // this.isFormSubmitted=false;
          swal({
            title: 'Client  Updated Successfully',
            text: 'You Successfully  Updated Client',
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: 'rgb(17, 205, 239)',
            cancelButtonColor: 'rgb(245, 54, 92)',
            confirmButtonText: 'Yes'
          })
        } else {
          // this.isFormSubmitted=false;
        }
      }
    });
}

}
